import './AuthStatus.css'

function AuthStatus({ isValid, loading, error }) {
  const getStatusText = () => {
    if (loading) return 'Memvalidasi...'
    if (error) return `Error: ${error}`
    if (isValid === true) return 'Valid ✓'
    if (isValid === false) return 'Tidak Valid ✗'
    return 'Belum divalidasi'
  }

  const getStatusClass = () => {
    if (loading) return 'status-loading'
    if (error) return 'status-error'
    if (isValid === true) return 'status-valid'
    if (isValid === false) return 'status-invalid'
    return 'status-pending'
  }

  return (
    <div className="card auth-status">
      <h2>Status Autentikasi</h2>
      <div className={`status ${getStatusClass()}`}>
        {loading && <div className="spinner"></div>}
        <span>{getStatusText()}</span>
      </div>
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
    </div>
  )
}

export default AuthStatus

